export function formatKM(value) {
  const n = Number(value);
  if (isNaN(n)) return "0,00 KM";
  return (
    n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " KM"
  );
}

export function formatMoney(value, currency) {
  const n = Number(value) || 0;
  const s = n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency === "EUR" ? `${s} €` : `${s} KM`;
}

export function formatNum(value, digits = 0) {
  const n = Number(value);
  if (isNaN(n)) return "0";
  return n.toLocaleString("de-DE", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateStr));
  if (m) return `${m[3]}.${m[2]}.${m[1]}.`;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}.${d.getFullYear()}.`;
}

export function monthLabel(key) {
  // key = "YYYY-MM"
  const names = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"];
  const [, m] = (key || "").split("-");
  const idx = parseInt(m, 10) - 1;
  return names[idx] || key;
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / 86400000);
}

export function deadlineLabel(dateStr) {
  const n = daysUntil(dateStr);
  if (n === null) return { text: "—", tone: "muted" };
  if (n < 0) return { text: `Isteklo prije ${Math.abs(n)} d`, tone: "danger" };
  if (n === 0) return { text: "Danas!", tone: "danger" };
  if (n === 1) return { text: "Sutra", tone: "warning" };
  if (n <= 3) return { text: `Za ${n} dana`, tone: "warning" };
  return { text: `Za ${n} dana`, tone: "info" };
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function exportCSV(filename, headers, rows) {
  const esc = (v) => {
    const s = v === null || v === undefined ? "" : String(v);
    if (s.includes(";") || s.includes("\n") || s.includes('"')) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  };
  const lines = [headers.map(esc).join(";")];
  rows.forEach((r) => lines.push(r.map(esc).join(";")));
  const bom = "\uFEFF";
  const blob = new Blob([bom + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function parseDecimal(v) {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return v;
  let s = String(v).trim();
  if (s.includes(",") && s.includes(".")) s = s.replace(/\./g, "").replace(",", ".");
  else if (s.includes(",")) s = s.replace(",", ".");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

export function toInputComma(v) {
  if (v === null || v === undefined || v === "") return "";
  return String(v).replace(".", ",");
}
